import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userDeposit } from "../../../../../../../common/types/AdminInfo/userDeposit";
import { AdminPanel } from "../../../../../../../services";

import "./DepositPage.scss";

interface IIDepositPage {
  setSelectedPaymentMethod: React.Dispatch<
    React.SetStateAction<undefined | userDeposit>
  >;
}

const DepositPage = ({ setSelectedPaymentMethod }: IIDepositPage) => {
  const nanvigate = useNavigate();
  const [paymentMethods, setPaymentMethods] = useState<userDeposit[] | []>([]);

  useEffect(() => {
    async function getPayemntMethods() {
      try {
        const res = await AdminPanel.userDeposit("?filter[type]=1");
        setPaymentMethods(res.data);
        setSelectedPaymentMethod(res.data[0]);
      } catch (e) {
        console.error(e);
      }
    }
    getPayemntMethods();
  }, []);

  const handleSelectMethod = (item: userDeposit) => {
    const selectedMethodName = item.payment_name || item.name;
    setSelectedPaymentMethod(item);
    nanvigate({
      search: `?profile=open&account=balance&page=deposit&selectedGroup=all&selectedMethod=${selectedMethodName}`,
    });
  };
  return (
    <div className="dep-w-info-bc" data-scroll-lock-scrollable="">
      <div className="m-block-nav-items-bc">
        {paymentMethods.map((item) => {
          return (
            <div
              className="m-nav-items-list-item-bc "
              key={item.id}
              onClick={() => handleSelectMethod(item)}
            >
              <div className="nav-ico-w-row-bc">
                <img
                  className="payment-logo"
                  src={item?.logo ? item.logo : ""}
                  alt=""
                />
              </div>
              <p className="m-nav-list-item-title-bc">{item.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { DepositPage };
